import { chakra, HTMLChakraProps } from '@chakra-ui/react';
import { HTMLMotionProps, motion, Variants } from 'framer-motion';
import * as React from 'react';

export type MotionListItemProps = HTMLChakraProps<'li'> & HTMLMotionProps<'li'>;
// @ts-ignore
export const MotionListItem = motion<MotionListItemProps>(chakra.li);

const variants: Variants = {
  exit: {
    opacity: 1,
    y: 4,
    display: 'none'
  },
  enter: {
    opacity: 1,
    y: 0,
    display: 'block',
    transition: {
      duration: 0.3
    }
  }
};
// @ts-ignore
export const NavListItem = (props: MotionListItemProps) => <MotionListItem variants={variants} {...props} />;
